export default __webpack_public_path__ + "static/media/store-connections.0aeb4f1d.png";